import React from 'react'
import AppLogo from '../../../assets/img/logo.png';

const Branding = ({ logo }) => {
    return (
        <div className="branding">
            <img
                src={logo ?? AppLogo}
                alt="App Logo"
                className="app-logo"
                onClick={() => (window.location.href = '/')}
            />
        </div>
    )
}

export default Branding